// Configuration for different environments
const config = {
  // Development environment (local) - use direct server URL
  development: {
    API_URL: '/api',
    PUBLIC_API_URL: '/public-api/v1',
    FEATURE_FLAGS: {
      WHATSAPP_SECTION: false
    }
  },
  // Phone testing environment
  phoneTest: {
    API_URL: 'http://192.168.0.253:5001/api',
    PUBLIC_API_URL: 'http://192.168.0.253:5001/public-api/v1',
    FEATURE_FLAGS: {
      WHATSAPP_SECTION: false
    }
  },
  // Production environment - NOW USING AWS EB SERVER
  production: {
    // Since the frontend is served from the same AWS EB server as the API,
    // use a relative path to avoid CORS issues
    API_URL: '/api',
    PUBLIC_API_URL: '/public-api/v1',
    FEATURE_FLAGS: {
      WHATSAPP_SECTION: false
    }
  },
  // Glitch environment (both frontend and backend on Glitch)
  glitch: {
    // When hosting both frontend and backend on Glitch, we can use a relative path
    API_URL: '/api',
    PUBLIC_API_URL: '/public-api/v1',
    FEATURE_FLAGS: {
      WHATSAPP_SECTION: false
    }
  },
  // Render environment configuration
  render: {
    // When using Render, the API is at the API service's URL
    API_URL: 'https://yesodcopilot-api.onrender.com/api',
    PUBLIC_API_URL: 'https://yesodcopilot-api.onrender.com/public-api/v1',
    FEATURE_FLAGS: {
      WHATSAPP_SECTION: false
    }
  },
  // AWS Elastic Beanstalk environment - no longer hardcoded protocol
  aws: {
    API_URL: `//${window.location.hostname}/api`,
    PUBLIC_API_URL: `//${window.location.hostname}/public-api/v1`,
    FEATURE_FLAGS: {
      WHATSAPP_SECTION: false
    }
  },
  // AWS environment with default protocol
  awsFallback: {
    API_URL: '/api',  // Use a relative path for the API
    PUBLIC_API_URL: '/public-api/v1',
    FEATURE_FLAGS: {
      WHATSAPP_SECTION: false
    }
  }
};

// Debugging environment detection
console.log('Current hostname:', window.location.hostname);
console.log('Current URL:', window.location.href);
console.log('Current protocol:', window.location.protocol);

// Determine current environment
// Check if we're on Glitch or Render by looking at the hostname
const isGlitch = window.location.hostname.includes('.glitch.me');
const isRender = window.location.hostname.includes('.onrender.com');
const isPhoneTest = window.location.hostname === '192.168.0.253';
const isAWS = window.location.hostname.includes('elasticbeanstalk.com');
const isProduction = process.env.NODE_ENV === 'production';
const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

// New: Check if we might be on AWS without the hostname containing 'elasticbeanstalk.com'
// This would be the case if using a custom domain or direct IP access
const mightBeAWS = isProduction && !isGlitch && !isRender && !isLocalhost && !isPhoneTest && !isAWS;

// Set environment
let env = 'development';
if (isGlitch) env = 'glitch';
if (isRender) env = 'render';
if (isPhoneTest) env = 'phoneTest';
if (isAWS) env = 'aws';
// If we might be on AWS but without the elasticbeanstalk.com domain, use the awsFallback
if (mightBeAWS) env = 'awsFallback';

// Log the detected environment
console.log('Detected environment:', env);
console.log('Using API URL:', config[env].API_URL);

// Share URL generator utility - SIMPLIFIED for direct links
const generateShareUrl = (type, id) => {
  // Detect if we're on QA or Production based on hostname
  const isQA = window.location.hostname.includes('qa.yesod.us');
  const isProduction = window.location.hostname.includes('www.yesod.us') || 
                       window.location.hostname === 'yesod.us';
  
  // Determine the base URL based on environment
  let baseUrl, frontendUrl;
  
  if (env === 'development') {
    baseUrl = 'http://localhost:5001';
    frontendUrl = 'http://localhost:3000';
  } else if (env === 'phoneTest') {
    baseUrl = 'http://192.168.0.253:5001';
    frontendUrl = 'http://192.168.0.253:3000';
  } else if (isQA) {
    // QA environment
    baseUrl = 'https://qa.yesod.us';
    frontendUrl = 'https://qa.yesod.us';
  } else {
    // Production or default
    baseUrl = 'https://www.yesod.us';
    frontendUrl = 'https://www.yesod.us';
  }
  
  // For all share types, use backend share endpoints (with OG tags for social media previews)
  switch (type) {
    case 'invite':
    case 'group':
      return `${baseUrl}/api/share/invite/${id}`;
    case 'event':
      return `${baseUrl}/api/share/event/${id}`;
    case 'class':
      return `${baseUrl}/api/share/class/${id}`;
    default:
      return `${baseUrl}/api/share/invite/${id}`;
  }
};

export const createShareLinks = {
  // Generate a shareable URL for a group
  group: (groupId) => generateShareUrl('group', groupId),
  
  // Generate a shareable URL for an event
  event: (eventId) => generateShareUrl('event', eventId),
  
  // Generate a shareable URL for a class
  class: (classId) => generateShareUrl('class', classId),
  
  // Generate a shareable URL for an invitation
  invite: (groupId) => generateShareUrl('invite', groupId)
};

// Export config for current environment
export default config[env];